// Les textes de l'accueil qui dépendent de la structure servie (nombre et noms des
// thématiques). Sortis de LandingPage.tsx le 11/10/2026 pour que les maquettes vivantes
// de /admin/design affichent EXACTEMENT les mêmes — sans copie qui dériverait.
import { nomsThematiques, separateurListe, type StructureObservatoire } from './structure'

// Sources officielles agrégées — noms bruts (aucun logo externe : autonomie + zéro CDN).
export const SOURCES = ['INSEE', 'DGFiP', 'DGCL', 'France Travail', 'CAF', 'SDES', 'DREES', 'ADEME', 'MENJ', 'etc.']

// Chiffres massue — VÉRIFIÉS en prod le 12/07 (35 020 communes, 1 552 442 observations).
// NB : on n'affiche PAS de nombre d'indicateurs tant que la couverture réelle n'est pas
// mesurée (chantier A-D3) — « 100 % officielles » est en revanche inattaquable.
// A20 (08/10) : STATS, GAINS et OBTENEZ sont des FONCTIONS de la structure servie
// (`useStructure`) — le nombre de thématiques suit le drapeau du serveur, plus le build.
export const STATS = (s: StructureObservatoire) => [
  { v: '~35 000', l: 'communes de France' },
  // « 10 » vivait en dur ici depuis avant #151 : la landing annonçait dix thématiques
  // quand la prod en sert douze — le bug exact que #151 corrigeait ailleurs, repéré à
  // la recette visuelle du 07/09. Le nombre servi, jamais le littéral.
  { v: String(s.nb_themes), l: 'thématiques' },
  { v: '100 %', l: 'données officielles' },
  // Mesuré en prod le 02/08 : 144 070 449 lignes vivantes sur 122 tables, base de 63 Go.
  // L'ancien « +1,5 M d'observations historisées » ne comptait qu'une famille de tables
  // (les observations d'indicateurs, 2,09 M aujourd'hui) et sous-vendait la base d'un
  // facteur 70. Le nouveau chiffre compte TOUTES les données officielles ingérées :
  // cadastre, DVF, qualité de l'air, recensement, délinquance, permis, dotations…
  { v: '+140 M', l: 'de données officielles' },
]

export const GAINS = (s: StructureObservatoire) => [
  {
    titre: 'Du temps',
    texte: "Fini les heures à courir après les fichiers INSEE, DGFiP ou DGCL, à les nettoyer " +
      "et à les recroiser. Tout est déjà réuni, à jour, sur la page de votre commune.",
  },
  {
    titre: "De l'argent",
    texte: "Réunir et tenir à jour ces données demande du temps et des compétences rares. " +
      "Vous accédez au résultat pour le prix d'un abonnement — dès 600 € HT/an, sans " +
      "recrutement dédié.",
  },
  {
    titre: 'Une compétence rare',
    // Ce que la carte promet existe et se vérifie à l'écran : chaque section porte ses
    // sources en pied, chaque indicateur sa fiche technique, chaque analyse sa note de
    // méthode. Rien d'inventé ici — c'est l'état de la prod.
    texte: `Croiser ${s.nb_themes} thématiques, comparer votre commune à sa strate, historiser les ` +
      "millésimes : un savoir-faire de data analyst territorial, intégré à l'outil. " +
      "Chaque chiffre porte sa source et son millésime, vérifiables d'un clic.",
  },
  {
    titre: 'De meilleures décisions',
    texte: "Débat d'orientation budgétaire, dossiers DETR/DSIL, conseil municipal : des " +
      "chiffres sourcés, datés et commentés, prêts à présenter en séance.",
  },
]

export const OBTENEZ = (s: StructureObservatoire) => [
  `${s.nb_themes} thématiques : ${nomsThematiques(s).join(separateurListe(s))}`,
  'Des analyses rédigées en note de synthèse',
  'Le positionnement de votre commune face aux communes comparables (benchmarks de strate)',
  "L'historisation des millésimes : voir d'où vous venez, pas seulement où vous êtes",
  'Le téléchargement en PDF, présentable tel quel en conseil municipal',
  // Marc 02/08 : l'export tableur n'était nulle part sur la vitrine alors qu'il existe —
  // c'est pourtant l'argument qui rassure un service qui veut retravailler les chiffres.
  "L'export des données en Excel et CSV, pour retravailler les chiffres chez vous",
]
